import axios from "axios";

const baseURL = "/api/cdk/admin-services/v1";
const baseURLSubs = "/api/cdk/subscription-validation/v1";

const URL = {
  config: `${baseURL}/config`,
  getCNumber: `${baseURL}/cNumber`,
  listStores: `${baseURL}/list/stores`,
  validateSubscription: `${baseURLSubs}/validate-subscription`
};

const HEADERS = {
  "Content-Type": "application/json"
};

const AdminService = {
  config: async () => {
    const response = await axios.get(`${URL.config}`, { headers: HEADERS });
    return response.data;
  },
  getCNumber: async () => {
    const response = await axios.get(`${URL.getCNumber}`, { headers: HEADERS });
    return response.data;
  },
  getStores: async () => {
    const response = await axios.get(`${URL.listStores}`, { headers: HEADERS });
    return response.data;
  },
  validateSubscription: async (cNumber, logonName) => {
    const response = await axios.get(
      `${URL.validateSubscription}/${cNumber}/${logonName}`,
      {
        headers: HEADERS
      }
    );
    return response.data;
  }
};

export default AdminService;
